import React, { Component } from 'react';
import axios from "axios";
import '../../css/components/MyTask/MyTask.css';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import AxiosInstance from '../AxiosInstance/AxiosInstance';
import { Link } from 'react-router-dom';


class MyTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //table_data: [{ "col1": "first", "col2": "f", "col3": "Oct 22 2015 11:35AM" }, { "col1": "second", "col2": "l", "col3": "Oct 22 2015 11:35AM" }, { "col1": "third", "col2": "l", "col3": "Oct 22 2016 11:35AM" }, { "col1": "fourth", "col2": "l", "col3": "Oct 22 2017 11:35AM" }, { "col1": "fifth", "col2": "l", "col3": "Oct 22 2018 11:35AM" }],
      table_data: [],
      totalSize: 5,
    };

    this.SelectMyTask();


  }

  SelectMyTask() {

    AxiosInstance({
      method: 'Post',
      url: '/tbSTD_m_MyTask/SelectMyTask',
      errorHandle: true,
      data: {
        stype: 'data',
        sFilterBy: 'Latest'
      }
    })
      .then(response => {
        this.setState({
          table_data: response.data
        });
      })
      .catch(function (error) {
      });

  }


  render() {
    return (
      <Card>
        <CardHeader className="d-flex align-item-center">
          <h4 className="font-weight-semi-bold" data-langid="2041.01"> My Task </h4>
          <div className="d-flex justify-content-center align-items-center btn-add col-sm-4  col-md-3 col-lg-2 ">
            <Link to="/mytask" className="card-header-action"><small className="" data-langid="4020.01">view more</small></Link>
          </div>
        </CardHeader>
        <CardBody >
          <div className="mytaskdetails">
            <Table className="card-mytask">
              <tbody>
                {this.state.table_data.sort((a, b) => a.sort - b.sort).map((data, i) => {
                  if (i < this.state.totalSize)
                    return (
                      <tr key={i}>
                        <td className="taskList" dangerouslySetInnerHTML={{ __html: data.col1 }} />
                        <td className="dateTime">{data.sort}</td>
                      </tr>
                    )
                })}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card >

    )
  }




}

export default MyTask; 
